import { DateTimeWithPrecision } from "@/Common/Models/DateTimeWithPrecision";
import { NonFunctionProperties } from "@/Common/Models/NonFunctionProperties";
import { CareElementFrequencyType } from "../CareElementFrequencyType";
import { CareElementOperatorType } from "../CareElementOperatorType";
import { BaseCareElement } from "./BaseCareElement";
import { CareElementType } from "./CareElementType";

export class IntegerReviewedCareElement extends BaseCareElement {
    public Name: string;
    public CareElementType: CareElementType.IntegerReviewed;
    public Value?: number | null;
    public Target?: number | null;
    public DateReviewed?: Date | null;
    public LastReviewedDate?: Date | null;
    public Frequency?: CareElementFrequencyType;
    public Operator?: CareElementOperatorType;
    public DateReviewedWithPrecision?: DateTimeWithPrecision;

    public constructor(init?: NonFunctionProperties<IntegerReviewedCareElement>) {
        super();
        this.CareElementType = CareElementType.IntegerReviewed;
        this.Name = init?.Name ?? "";
        this.Value = init?.Value ?? null;
        this.Target = init?.Target ?? null;
        this.SubSectionName = init?.SubSectionName ?? "";
        this.DateReviewed = init?.DateReviewed ?? null;
        this.LastReviewedDate = init?.LastReviewedDate ?? null;
        this.Frequency = init?.Frequency ?? null;
        this.Operator = init?.Operator ?? null;
        this.DateReviewedWithPrecision = DateTimeWithPrecision.getDate(init?.DateReviewed);
    }
}
